import { useCallback, useState } from "react";
import { usePermissions } from "@/contexts/permissions-context";
import { archiveBooking, preflightArchiveBooking, preflightUnarchiveBooking, unarchiveBooking, type BookingArchiveOperation, type BookingArchiveResult } from "@/services/booking-archive-api";

export function useBookingArchive() {
  const { hasPermission } = usePermissions();
  const [loading, setLoading] = useState(false);
  const canWrite = hasPermission("Bookings", "WRITE");
  const preflight = useCallback(async (id: number, operation: BookingArchiveOperation) => {
    setLoading(true); try { return await (operation === "Archive" ? preflightArchiveBooking(id) : preflightUnarchiveBooking(id)); } finally { setLoading(false); }
  }, []);
  const execute = useCallback(async (id: number, operation: BookingArchiveOperation, reason?: string): Promise<BookingArchiveResult> => {
    if (!canWrite) throw new Error("No ten�s permiso para modificar Bookings.");
    setLoading(true); try { return await (operation === "Archive" ? archiveBooking(id, reason) : unarchiveBooking(id)); } finally { setLoading(false); }
  }, [canWrite]);
  return { canWrite, loading, preflight, execute };
}
